export function getView(collapse, type, boards) {
  if (type !== 'other-boards') {
    return !collapse
  }

  if (collapse === true && boards?.length === 0) {
    return true
  }
}
